import React, { useEffect, useState } from "react";
import Rating from "react-rating";
import useAuth from "../../hooks/useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faClock,
  faBookReader,
  faLanguage,
  faCertificate,
} from "@fortawesome/free-solid-svg-icons";
import "./CourseDetails.scss";
import { useParams, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { useLanguage } from "../../contexts/LanguageContext";

const CourseDetails = () => {
  const { language } = useLanguage();
  const [details, setDetails] = useState({});
  const [activeTab, setActiveTab] = useState("overview");
  const { handleSubmit, reset } = useForm();
  const { courseId } = useParams();
  const { user } = useAuth();
  const history = useHistory();
  const [lessons, setLessons] = useState([]);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!user) return;

    const fetchData = async () => {
      try {
        const res = await fetch(
          `https://admin.internationalskillsacademy.com/api/courses/${courseId}/?user=${user.id}&lang=${language}`
        );
        if (!res.ok) throw new Error("Fetch failed");
        const data = await res.json();

        console.log(data);

        const enrolledCourses =
          JSON.parse(localStorage.getItem("enrolledCourses")) || {};
        const isLocallyEnrolled = enrolledCourses[courseId];

        if (isLocallyEnrolled) {
          data.is_enrolled = true;
        }

        setDetails(data);
        loadLessons(data.lessonss);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, [courseId, language, user]);

  const saveEnrollment = (courseId) => {
    const enrolledCourses =
      JSON.parse(localStorage.getItem("enrolledCourses")) || {};
    enrolledCourses[courseId] = true;
    localStorage.setItem("enrolledCourses", JSON.stringify(enrolledCourses));
  };

  const loadLessons = async () => {
    try {
      const resArticles = await fetch(
        `https://admin.internationalskillsacademy.com/api/uploads/?lang=${language}`
      );
      const resVideos = await fetch(
        `https://admin.internationalskillsacademy.com/api/upload-videos/?lang=${language}`
      );

      const articlesData = await resArticles.json();
      const videosData = await resVideos.json();

      const combined = [
        ...articlesData.results.map((item) => ({ ...item, type: "article" })),
        ...videosData.results.map((item) => ({ ...item, type: "video" })),
      ];

      setLessons(combined);
    } catch (err) {
      console.error("Error loading lessons:", err);
    }
  };

  const {
    title = "",
    categories = [],
    lessonss = [],
    price = 0,
    image = "",
    // summary_ar = "",
    // summary_en = "",
    summary,
    author = {},
    is_enrolled,
    duration = 0,
    lessons_number = 0,
  } = details;

  console.log(details, "HAHAJafar");

  const onSubmit = () => {
    if (!user) {
      alert(
        language === "ar" ? "يرجى تسجيل الدخول أولاً." : "Please log in first."
      );
      return;
    }

    const couponFormat = /^[a-zA-Z0-9-]{36}$/;
    if (!couponFormat.test(couponCode)) {
      alert(language === "ar" ? "الكوبون غير صالح" : "Invalid coupon");
      return;
    }

    fetch(
      `https://admin.internationalskillsacademy.com/api/courses/${courseId}/enroll/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": language,
          Authorization: `token ${user.token}`,
        },
        body: JSON.stringify({ coupon_code: couponCode }),
      }
    )
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Enrollment failed");

        setShowSuccessMessage(true);
        setShowCouponModal(false);
        setCouponCode("");
        setDetails((prev) => ({ ...prev, is_enrolled: true }));
        saveEnrollment(courseId);
        reset();
      })
      .catch((error) => {
        console.error("Coupon error:", error);
        setErrorMessage(error.message);
      });
  };

  const handleVideoProgress = (lessonId) => (e) => {
    const { currentTime, duration } = e.target;
    const percent = (currentTime / duration) * 100;
    if (percent >= 70) {
      sendWatchHistory(user.id, courseId, lessonId);
    }
  };

  const sendWatchHistory = (userId, courseId, lessonId) => {
    fetch(
      `https://admin.internationalskillsacademy.com/api/watch_history/?lang=${language}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": language,
          Authorization: `token ${user.token}`,
        },
        body: JSON.stringify({
          user: userId,
          course: courseId,
          lesson: lessonId,
        }),
      }
    ).catch((err) => console.error("Watch history error:", err));
  };

  const renderTabContent = () => {
    if (activeTab === "overview") {
      return (
        <div className="indicator-details">
          <h4>
            {language === "ar" ? "تفاصيل الدورة التعليمية" : "Course Details"}
          </h4>
          <p>
            {language === "ar"
              ? details.summary_ar || summary
              : details.summary_en || summary}
          </p>
        </div>
      );
    }

    if (activeTab === "curriculum") {
      return (
        <div>
          <h4>{language === "ar" ? "المقرر" : "Curriculum"}</h4>
          {user ? (
            is_enrolled ? (
              <Accordion>
                {lessonss.map((lesson, index) => (
                  <Accordion.Item key={lesson.id} eventKey={String(index)}>
                    <Accordion.Header>
                      {language === "ar" ? lesson.title_ar : lesson.title_en}
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>{lesson.short_description}</p>
                      <p>
                        {language === "ar" ? "المحتوى:" : "Content:"} <br />
                        {lesson.long_description}
                      </p>
                      {lesson.videos && (
                        <video
                          width="400"
                          controls
                          onTimeUpdate={handleVideoProgress(lesson.id)}
                        >
                          <source src={lesson.videos.video} type="video/mp4" />
                        </video>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            ) : (
              <p>
                {language === "ar"
                  ? "يجب التسجيل في الدورة لرؤية محتوى الدروس."
                  : "You must enroll in the course to see lesson content."}
              </p>
            )
          ) : (
            <p>
              {language === "ar"
                ? "يرجى تسجيل الدخول لعرض محتوى الدروس."
                : "Please log in to view lesson content."}
            </p>
          )}
        </div>
      );
    }

    if (activeTab === "instructor") {
      return (
        <div>
          <h4>{language === "ar" ? "المدرب" : "Instructor"}</h4>
          <p>{author.username}</p>
          <p>{author.teacherprofile?.bio}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="details-section">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-8 mb-5 mb-lg-0">
            <div className="detail-box">
              <h3 className="title">{title}</h3>
              <p className="category">{categories[0]?.title || ""}</p>

              {/* Instructor */}
              <div className="instructor">
                <div className="box">
                  <img
                    src={author.teacherprofile?.image || ""}
                    alt="Instructor"
                  />
                </div>
                <div className="box">
                  <h5>
                    {language === "ar" ? "أُنشأ من قبل :" : "Created by :"}
                  </h5>
                  <p className="mb-0">{author.username}</p>
                </div>
              </div>

              {/* Tabs */}
              <div className="bottom-area">
                <ul className="indicator">
                  <li
                    className={activeTab === "overview" ? "active" : ""}
                    onClick={() => setActiveTab("overview")}
                  >
                    {language === "ar"
                      ? "لمحة عن الدورة التعليمية"
                      : "Course Overview"}
                  </li>
                  <li
                    className={activeTab === "curriculum" ? "active" : ""}
                    onClick={() => setActiveTab("curriculum")}
                  >
                    {language === "ar" ? "المقرر" : "Curriculum"}
                  </li>
                  <li
                    className={activeTab === "instructor" ? "active" : ""}
                    onClick={() => setActiveTab("instructor")}
                  >
                    {language === "ar" ? "المدرب" : "Instructor"}
                  </li>
                </ul>
                {renderTabContent()}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="col-lg-4 ps-lg-5">
            <div className="purchase-course-box">
              <div className="img-box">
                <img className="img-fluid" src={image} alt="" />
              </div>
              <div className="info-box">
                <h4 className="price">{price} SP</h4>

                {user ? (
                  is_enrolled ? (
                    <p>
                      {language === "ar"
                        ? "مشترك بالفعل!"
                        : "Already enrolled!"}
                    </p>
                  ) : (
                    <button
                      onClick={() => setShowCouponModal(true)}
                      className="btn-black"
                    >
                      {language === "ar" ? "اشترك الآن" : "Enroll Now"}
                    </button>
                  )
                ) : (
                  <button
                    onClick={() => history.push("/login")}
                    className="btn-black"
                  >
                    {language === "ar"
                      ? "تسجيل الدخول للاشتراك"
                      : "Login to enroll"}
                  </button>
                )}

                <ul>
                  <li>
                    <span>
                      <FontAwesomeIcon className="icon" icon={faClock} />
                      {language === "ar" ? "المدة" : "Duration"}
                    </span>
                    <span>{duration}</span>
                  </li>
                  <li>
                    <span>
                      <FontAwesomeIcon className="icon" icon={faBookOpen} />
                      {language === "ar" ? "الدروس" : "Lessons"}
                    </span>
                    <span>{lessons_number}</span>
                  </li>
                  <li>
                    <span>
                      <FontAwesomeIcon className="icon" icon={faCertificate} />
                      {language === "ar" ? "شهادة" : "Certificate"}
                    </span>
                    <span>{language === "ar" ? "نعم" : "Yes"}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Success Message */}
      {showSuccessMessage && (
        <Alert
          style={{ position: "absolute", top: "100px", right: 0, left: 0 }}
          variant="success"
          onClose={() => setShowSuccessMessage(false)}
          dismissible
        >
          <Alert.Heading>
            {language === "ar"
              ? "تم الاشتراك بنجاح!"
              : "Successfully Enrolled!"}
          </Alert.Heading>
          <p>
            {language === "ar"
              ? "شكراً لاستخدامك كود الكوبون."
              : "Thank you for using your coupon."}
          </p>
        </Alert>
      )}

      {/* 🔐 Modal */}
      <Modal show={showCouponModal} onHide={() => setShowCouponModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language === "ar" ? "أدخل الكوبون" : "Enter Coupon"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            placeholder={language === "ar" ? "كود الكوبون" : "Coupon Code"}
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            className="form-control"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowCouponModal(false)}>
            {language === "ar" ? "إلغاء" : "Cancel"}
          </Button>
          <Button
            style={{ backgroundColor: "#2f2d52", border: "1px solid #2f2d52" }}
            onClick={handleSubmit(onSubmit)}
          >
            {language === "ar" ? "تأكيد" : "Confirm"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CourseDetails;
